
<app-plan-expired *ngIf="disable"></app-plan-expired>
<div class="page" #page>
  <div class="main-card" #mainCard>
    <div class="left-card">
      <app-left-card
        [(currentTab)]="currentTab"
        (statusScroll)="moveScroll($event)"
        [publicCardData]="publicCardData"
        [socialNetworksList]="socialNetworksList"
        [logeado]="logeado"
      ></app-left-card>
    </div>
    <div class="center-card">
      <app-center-card
        [(currentTab)]="currentTab"
        (statusScroll)="moveScroll($event)"
        [publicCardData]="publicCardData"
        [usuario]="usuario"
      ></app-center-card>
    </div>
    <div class="right-card">
      <app-right-card
        [(currentTab)]="currentTab"
        (statusScroll)="moveScroll($event)"
        [galleryList]="galleryList"
        [servicesList]="servicesList"
        [galleryCompanyList]="galleryCompanyList"
        [servicesCompanyList]="servicesCompanyList"
      ></app-right-card>
    </div>
  </div>
</div>


<!-- Pidió Ing. Uzziel se omita este botón por petición de los clientes -->
<!-- <button
  mat-raised-button
  class="mat-danger new-card"
  *ngIf="currentTab === 3 && publicCardData.crearTarjeta"
  [routerLink]="'/register'"
>
  {{ "create_your_card_now" | translate }}
  <mat-icon class="ms-3">star</mat-icon>
</button> -->


<a
  href="{{
    'https://api.whatsapp.com/send?phone=' +
      publicCardData.claveTelefono +
      this.publicCardData.telefono +
      '&text=¡Hola, Necesitó más información!'
  }}"
  target="_blank"
  class="wp_float"
  *ngIf="this.publicCardData.telefono !== ''"
>
  <i class="fab fa-whatsapp ml-2" style="font-size: 20px"></i>
</a>
